import { render, staticRenderFns } from "./final-result.vue?vue&type=template&id=a676bd90&"
import script from "./final-result.vue?vue&type=script&lang=js&"
export * from "./final-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports